/* Your Legacy — carousels (pagination dots), reviews (gap-free masonry, jump-free "see more",
   photo lightbox). Progressive enhancement: without JS everything stays usable.
   Labels follow the page language (<html lang>): English by default, Spanish on /es pages. */
(function () {
  "use strict";
  var ES = /^es/i.test(document.documentElement.lang || "");
  var L = ES ? { go: "Ir al elemento ", close: "Cerrar" } : { go: "Go to item ", close: "Close" };
  function build(rail) {
    var slides = Array.prototype.slice.call(rail.children);
    if (slides.length < 2 || rail.dataset.dots) return;
    rail.dataset.dots = "1";
    var nav = document.createElement("div");
    nav.className = "st-dots";
    var dots = slides.map(function (slide, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "st-dot";
      b.setAttribute("aria-label", L.go + (i + 1));
      b.addEventListener("click", function () {
        slide.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      });
      nav.appendChild(b);
      return b;
    });
    rail.parentNode.insertBefore(nav, rail.nextSibling);
    dots[0].setAttribute("data-on", "");
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = slides.indexOf(e.target);
        dots.forEach(function (d, j) { d.toggleAttribute("data-on", j === i); });
      });
    }, { root: rail, threshold: 0.6 });
    slides.forEach(function (s) { io.observe(s); });
  }
  function init() {
    document.querySelectorAll(".cbc .st-vids, .cbc .st-imgs:not(.st-marquee)").forEach(build);
  }
  var ROW = 4;
  function masonry() {
    var grids = document.querySelectorAll(".cbc .st-revs");
    grids.forEach(function (g) {
      var cs = getComputedStyle(g);
      if (cs.display !== "grid") return;
      var cols = cs.gridTemplateColumns.split(" ").filter(Boolean).length;
      var gap = parseFloat(cs.columnGap) || 18;
      var cards = Array.prototype.filter.call(g.querySelectorAll(".st-rev"), function (c) { return c.offsetParent !== null; });
      cards.forEach(function (c) { c.style.gridColumn = ""; c.style.gridRow = ""; });
      if (cols < 2) {
        g.classList.remove("st-revs--mas");
        g.querySelectorAll(".st-rev").forEach(function (c) { c.style.gridColumn = ""; c.style.gridRow = ""; });
        return;
      }
      g.classList.add("st-revs--mas");
      var heights = cards.map(function (c) { return c.getBoundingClientRect().height; });
      var cursor = [];
      for (var i = 0; i < cols; i++) cursor.push(0);
      cards.forEach(function (card, i) {
        var col = 0;
        for (var k = 1; k < cols; k++) if (cursor[k] < cursor[col]) col = k;
        var span = Math.ceil((heights[i] + gap) / ROW);
        card.style.gridColumn = (col + 1) + " / span 1";
        card.style.gridRow = (cursor[col] + 1) + " / span " + span;
        cursor[col] += span;
      });
    });
  }
  var mT;
  function relayout() { clearTimeout(mT); mT = setTimeout(masonry, 60); }
  function watchImages() {
    document.querySelectorAll(".cbc .st-revs img").forEach(function (im) {
      if (im.complete) return;
      im.addEventListener("load", relayout, { once: true });
      im.addEventListener("error", relayout, { once: true });
    });
  }
  function moreReviews() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".st-morebtn2");
      if (!btn) return;
      var col = btn.closest(".st-revcol");
      if (!col) return;
      e.preventDefault();
      var y = window.scrollY;
      col.setAttribute("data-all", "");
      var cb = col.querySelector(".st-moretog");
      if (cb) cb.checked = true;
      window.scrollTo(0, y);
      masonry(); watchImages(); relayout();
    });
  }
  function lightbox() {
    if (document.querySelector(".cbc-lb")) return;
    var lb = document.createElement("div");
    lb.className = "cbc-lb";
    lb.innerHTML = '<button class="cbc-lb__x" aria-label="' + L.close + '">&times;</button><figure><img alt=""><figcaption></figcaption></figure>';
    document.body.appendChild(lb);
    function close() { lb.removeAttribute("data-on"); document.body.style.overflow = ""; }
    lb.addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    document.addEventListener("click", function (e) {
      var img = e.target.closest(".st-revpics img");
      if (!img) return;
      e.preventDefault();
      lb.querySelector("img").src = img.currentSrc || img.src;
      var rev = img.closest(".st-rev");
      var who = rev && rev.querySelector(".st-revwho b");
      var cap = lb.querySelector("figcaption");
      cap.textContent = who ? who.textContent.trim() : "";
      cap.style.display = who ? "" : "none";
      lb.setAttribute("data-on", "");
      document.body.style.overflow = "hidden";
    });
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", function(){init();lightbox();moreReviews();masonry();watchImages();}) : (init(), lightbox(), moreReviews(), masonry(), watchImages());
  window.addEventListener("resize", relayout);
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(relayout);
    document.querySelectorAll(".cbc .st-revs").forEach(function (g) { ro.observe(g); });
  }
  window.addEventListener("load", relayout);
  document.addEventListener("shopify:section:load", function () { init(); relayout(); });
})();
